angular.module('iqxCore')
  .controller('CandidateBankDetailsCtrl', function ($scope, FormSvc, ApiSvc, pinSvc, ApplicationSvc) {
  $scope.agencyManagesDetails=false

	if (!$scope.userHasRight('CANDBANKDETAILSEDIT')) {
		var footer = document.querySelectorAll('form .panel-heading .btn-primary')
		angular.forEach(footer, function(elm, key){
			footer[key].setAttribute('class', 'hide')
		})

		var formElements = document.querySelectorAll('form input')
		angular.forEach(formElements, function(elm, key){
			formElements[key].setAttribute('ng-disabled', 'true')
		})
	}

  $scope.refreshVals=function(){
    $scope.fetch()
    .then(function(){
      if ($scope.theRecord.HideDetails == 1) {
        $scope.agencyManagesDetails=true
      }
    })
  }

  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/NetCandidateBankDetails',
    saveAPI:'call/NetCandidateBankDetailsSet',
    saveWithPersonID:true,
    fetchWithPersonID:true,
    saveCleanFields:true,
    savePrefix:'p',
    autoEdit:false,
    questionnaire: {
      tagTarget: 'tags',
      tagLocation: 'P',
      questionGroup: '-11',
      id: ApplicationSvc.currentUser.personID,
      postVar: 'qanswers'
    }
  })

  $scope.refreshVals()
  
  $scope.bankDetailsOk=async function(){
    if (!$scope.isSwitchedOn('CHECKBANKMODULUS')) {return true}
    if ($scope.theRecord.BankSortCode==$scope.cleanRecord.BankSortCode && $scope.theRecord.BankAcNo==$scope.cleanRecord.BankAcNo) {return true}
    let res=await ApiSvc.exec($scope,'service/checkbankmodulus',{sortcode:$scope.theRecord.BankSortCode,accountnumber:$scope.theRecord.BankAcNo,iqxresult:'Y'})
    let mess=res.IQXResult.message
    if (mess=='Y') {return true}
    FormSvc.alert("Bank Details", mess+"\n\nIf you know the details are correct please contact the agency", "error")
    return false    
  }
 
  $scope.setEditing = function(enable){
    return pinSvc.prompt($scope)
    .then(function(pinValid){
      if(pinValid===true){
        $scope.theRecord.BankAcNo = ''
        $scope.theRecord.BankSortCode = ''

        FormSvc.setEditing($scope, true)
      }
    })
  }

  $scope.update=async function(){
    if(!$scope.theRecord.BankAcNo || $scope.theRecord.BankAcNo === '' || $scope.theRecord.BankAcNo.length !== 8){
      FormSvc.alert('', 'Account Number missing or incomplete', 'error')
      return false
    }
    //8 chars as there is 2 '-'
    if(!$scope.theRecord.BankSortCode || $scope.theRecord.BankSortCode === '' || $scope.theRecord.BankSortCode.length !== 8){
      FormSvc.alert('', 'Sort Code missing or incomplete', 'error')
      return false
    }

    let bok=await $scope.bankDetailsOk()
    if (!bok) {return}
  	return FormSvc.update($scope,true)
  	.then(function(res){
  		FormSvc.alert("Updated", "Your bank details have been updated.", "success")
      $scope.refreshVals()
  	})
  }
})
